import { defineMessages } from 'react-intl'

export const homeDevicesMessages = defineMessages({
  title: {
    id: 'homeDevices.title',
    description: 'Title for home devices page',
    defaultMessage: 'Configured Devices',
  },
  countItems: {
    id: 'homeDevicesMessages.countItems',
    description: 'Count Items for home devices page',
    defaultMessage: 'Items',
  },
  filterAll: {
    id: 'homeDevicesMessages.filterAll',
    description: 'Button FilterAll for home devices page',
    defaultMessage: 'All',
  },
  filterSavantOnly: {
    id: 'homeDevicesMessages.filterOnly',
    description: 'Button FilterSavantOnly for home devices page',
    defaultMessage: 'Savant Only',
  },
  filterUserInterfaces: {
    id: 'homeDevicesMessages.filterUserInterfaces',
    description: 'Button FilterUserInterfaces for home devices page',
    defaultMessage: 'User Interfaces',
  },
  roomDropdownPlaceholder: {
    id: 'homeDevicesMessages.roomDropdownPlaceholder',
    description: 'Placeholder for dropdown filter "Room" on home devices page',
    defaultMessage: 'Room',
  },
  deviceTypeDropdownPlaceholder: {
    id: 'homeDevicesMessages.deviceTypeDropdownPlaceholder',
    description:
      'Placeholder for dropdown filter "Devices Type" on home devices page',
    defaultMessage: 'Devices Type',
  },
  statusDropdownPlaceholder: {
    id: 'homeDevicesMessages.statusDropdownPlaceholder',
    description:
      'Placeholder for dropdown filter "Status" on home devices page',
    defaultMessage: 'Status',
  },
  searchPlaceholder: {
    id: 'homeDevicesMessages.searchPlaceholder',
    description: 'Search Placeholder for home devices page',
    defaultMessage: 'Search Device',
  },

  statusColumn: {
    id: 'homeDevicesMessages.statusColumn',
    description: 'Status Column for home devices page',
    defaultMessage: 'Status',
  },
  deviceNameColumn: {
    id: 'homeDevicesMessages.deviceNameColumn',
    description: 'Device Name Column for home devices page',
    defaultMessage: 'Device Name',
  },
  uidColumn: {
    id: 'homeDevicesMessages.uidColumn',
    description: 'UID Column for home devices page',
    defaultMessage: 'UID',
  },
  deviceTypeColumn: {
    id: 'homeDevicesMessages.deviceTypeColumn',
    description: 'Device Type Column for home devices page',
    defaultMessage: 'Device Type',
  },
  controllerColumn: {
    id: 'homeDevicesMessages.controllerColumn',
    description: 'Controller Column for home devices page',
    defaultMessage: 'Controller',
  },
  roomColumn: {
    id: 'homeDevicesMessages.roomColumn',
    description: 'Room Column for home devices page',
    defaultMessage: 'Room',
  },
  ipAddressColumn: {
    id: 'homeDevicesMessages.ipAddressColumn',
    description: 'IP Address Column for home devices page',
    defaultMessage: 'IP Address',
  },
  macColumn: {
    id: 'homeDevicesMessages.macColumn',
    description: 'MAC Column for home devices page',
    defaultMessage: 'Mac',
  },
  manufacturerColumn: {
    id: 'homeDevicesMessages.manufacturerColumn',
    description: 'Manufacturer Column for home devices page',
    defaultMessage: 'Manufacturer',
  },
})
